import { render, staticRenderFns } from "./MyCashRegister.vue?vue&type=template&id=45126c71"
import script from "./MyCashRegister.vue?vue&type=script&lang=js"
export * from "./MyCashRegister.vue?vue&type=script&lang=js"
import style0 from "./MyCashRegister.vue?vue&type=style&index=0&id=45126c71&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports